import React, { useState } from 'react';
import { Switch } from '@material-ui/core';
import axiosClient from 'http/axios-client';
import CollectionKeys from '../../../hooks/molecules/collection-keys';

async function updateSerial(availability, id) {
  try {
    await axiosClient.put(`${ CollectionKeys.SERIAL_NUMBER }/${ id }`, { appointment_availability: !availability });
  } catch (error) {
    console.log(error);
  }
}

function DisableAppointmentSwitch({ appointmentAvailable, id, refetch }) {
  const [ availability, setAvailability ] = useState(appointmentAvailable);
  const handleChange = async () => {
    // update UI
    setAvailability(!availability);
    await updateSerial(availability, id);

    if (undefined !== refetch) {
      refetch();
    }
  };

  return (
    <Switch
      checked={ availability }
      onChange={ handleChange }
      color='secondary'
      name='checkedB'
      inputProps={ { 'aria-label': 'availability checkbox' } }
    />
  );
}

export default DisableAppointmentSwitch;
